import React from "react"
import styled, { css } from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import classNames from "classnames"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons"
import { media } from "utils/Media"
import WPLink from "components/shared/WPLink"

const NavWrap = styled.nav`
	display: flex;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1;
	right: 1rem;

	@media ${media.lg} {
		right: 60px;
	}
	@media ${media.xl} {
		right: 70px;
	}

	${props => props.navActive && css`
		display: none;
	`}

	.sub-menu-wrapper {
		position: absolute;
		top: 0;
		left: 0;
		padding-top: 2rem;
		width: 100%;	
		min-width: 200px;
		.sub-menu {
					width: 100%;
					display: none;
					position: absolute;
					min-width: 150px;
					background-color: rgba(0,0,0,.85);		
					padding: .5rem;
					> a {
						text-transform: none;
						padding: 1rem;
					
					}
					li {
						padding: 0;
						margin: 0;
					}
					li a {
						padding: .35rem;
						&:hover {
							background-color: rgba(0, 178, 169,.75);
						}
					}
					li a span{
						font-size: 16px!important;
						
					}
					
		}
	}
	

	ul {
		padding: 0;
		margin: 0;
		display: none;
		list-style: none;
		
		@media ${media.xl} {
			display: flex;
		}
		
		&.buttons {
			display: flex;
			align-items: center;
		}
		
		li {
			padding-left: 0;
			span {
				padding-right: 5px;
			}
			svg {
				width: 100%;
				color: white;
				padding-left: 5px;
				font-size: 25px;
				max-width: 25px;
				max-height: 25px;
			}
			&:before {
				display: none;
			}
		}
		
		li:not(.book-tickets) {
			display: none;
			
			@media (min-width: 1300px) {
				display: flex;
				align-items: center;
				padding-right: 5px;
				position: relative;
			}
			@media (min-width: 1350px) {
				padding-right: 10px;
			}
			a {
				padding: 0 .65rem;
			}
			ul {
				margin: 0;
				padding: 0;

			}
			a, span {
				cursor: pointer;
				display: block;
				color: ${props => props.theme.colors.white};
				/* padding: 1rem .25rem; */
				text-transform: uppercase;
				font-size: 18px;
				font-family: ${props => props.theme.font.family.heading};
				//font-style: italic;
				font-weight: ${props => props.theme.font.weight.regular};
				text-decoration: none;
				@media (min-width: 1400px) {
					font-size: 18px;
				}
				
				&.active {
					position: relative;
					&:after {
						content: "";
						height: 4px;
						width: 100%;
						background-color: ${props => props.theme.colors.white};
						position: absolute;
						bottom: 0rem;
						left: 0;
					}
				}
			}
			
			a > span {
				padding: 0;
			}
			
			li {
				display: block;

			}
			
			&:hover {
				> a, > a span, > span {
					text-decoration: none;
					/* color: ${props => props.theme.colors.secondary}; */
				}
				
				.sub-menu {
					display: block;
					
				}
			}
		}
		
		.book-tickets {
			@media ${media.xl} {
				margin: 0 .5rem; 
			}
			
			a {
				span {
					padding: .5rem;
					@media ${media.md} {
						padding: 1rem;
					}
				}
			}
		}
	}
`

const Nav = (props) => {
	const data = useStaticQuery(graphql`
		query {
			allWpMenu(filter: {locations: {eq: PRIMARY}}) {
				edges {
					node {
						locations
						menuItems {
							nodes {
								url
								target
								label
								parentDatabaseId
								childItems {
									nodes {
										url
										target
										label
									}
								}
							}
						}
					}
				}
			}
			allWp {
				edges {
					node {
						...optionsFragment
					}
				}
			}
		}
	`)

	const menu = data.allWpMenu?.edges[0].node.menuItems
	const { bookTicketsUrl } = data.allWp.edges[0]?.node?.options?.acfOptions

	const checkLink = (link) => {
		let linkHtml

		if (link.url === "#") {
			linkHtml = <span dangerouslySetInnerHTML={{ __html: link.label }} />
		} else if (link.target !== null) {
			linkHtml = <a href={link.url} target={link.target} rel="noopener noreferrer" aria-label={link.label}><span dangerouslySetInnerHTML={{ __html: link.label }} /></a>
		} else {
			linkHtml = <WPLink url={link.url}><span dangerouslySetInnerHTML={{ __html: link.label }} className={classNames({
				active: props.path === link.url
			})}/></WPLink>
		}

		return linkHtml
	}

	const mainMenu = menu && menu.nodes.map((node, i) => {
		if (node.parentDatabaseId === 0) {
			return(
				<li key={i}>
					{checkLink(node)}
					{node.childItems.nodes.length > 0 &&
						<FontAwesomeIcon icon={faAngleDown} className="icon" />
					}
					{node.childItems.nodes.length > 0 &&
						<div className="sub-menu-wrapper">
							<ul className="sub-menu">
								{node.childItems.nodes.map((node, i) => {
									if (node.url === "#") {
										return (
											<li key={i}>
												<span dangerouslySetInnerHTML={{ __html: node.label }} />
											</li>
										)
									} else {
										return (
											<li key={i}>
												{node.target !== null ? (
													<a href={node.url} target={node.target}>
														<span dangerouslySetInnerHTML={{ __html: node.label }} />
													</a>
												) : (
													<WPLink url={node.url}>
														<span dangerouslySetInnerHTML={{ __html: node.label }} />
													</WPLink>
												)}
											</li>
										)
									}
								})}
							</ul>
						</div>
					}
				</li>
			)
		}
	})

	return (
		<NavWrap navActive={props.navActive}>
			<ul>
				{mainMenu}
			</ul>
			<ul className="buttons">
				{bookTicketsUrl && 
					<li className="book-tickets">
						<WPLink 
							url={bookTicketsUrl.url} 
							target={bookTicketsUrl.target} 
							button 
							color="secondary"
						>
							{bookTicketsUrl.title}
						</WPLink>
					</li>
				}
			</ul>
		</NavWrap>
	)
}

export default Nav
